import { PS, T } from '../../lib/theme';

interface KpiCardProps {
  label: string;
  value: string;
  /** Percent change vs previous period; null/undefined hides the chip. */
  delta?: number | null;
}

export function KpiCard({ label, value, delta }: KpiCardProps) {
  const hasDelta = delta !== null && delta !== undefined && Number.isFinite(delta);
  const up = hasDelta && (delta as number) >= 0;
  return (
    <div
      style={{
        background: PS.white,
        border: `1px solid ${PS.borderLight}`,
        borderRadius: 6,
        padding: '14px 16px',
        minWidth: 150,
        flex: '1 1 150px',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
      }}
    >
      <div style={{ ...T.label }}>{label}</div>
      <div style={{ ...T.sectionTitle, color: PS.nearBlack }}>{value}</div>
      {hasDelta && (
        <div
          style={{
            ...T.caption,
            color: up ? PS.success : PS.danger,
            margin: 0,
          }}
        >
          {up ? '▲' : '▼'} {Math.abs(delta as number).toFixed(0)}% vs prev
        </div>
      )}
    </div>
  );
}
